<template>
  <v-btn class="my-4 mx-n2 px-2" color="blue" text rounded @click="handleBack">
    <v-icon size="16" class="me-2">mdi-arrow-left</v-icon>
    {{ backText }}
  </v-btn>
</template>
<script>
import mixin from '@/mixins/mixin'

export default {
  name: 'RevViewBackButton',

  mixins: [mixin],

  computed: {
    hasPreviousPage() {
      return window.history.length > 1
    },

    backText() {
      return this.hasPreviousPage
        ? this.$t('organization_structure.route.back')
        : this.$t('common.home')
    },
  },

  methods: {
    handleBack() {
      if (this.hasPreviousPage) {
        this.$router.back()
      } else {
        this.$router.replace({ name: 'home' })
      }
    },
  },
}
</script>
